// extracted by mini-css-extract-plugin
export default {"Wrapper":"Congrats_Wrapper__FlPzw"};